import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";

import { FaRegEdit, FaFileExcel, FaRegTrashAlt } from "react-icons/fa";
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import HeaderName from "../HeaderName";
import SideBar from "../SideBar";
import { Tabs, Tab } from "@mui/material";
import { API_URL } from "../../../api/api";

const SpecialCommission = () => {
  const token = localStorage.getItem("token");
  const url = API_URL();

  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const navigate = useNavigate();

  const [showDoctor, setShowDoctor] = useState(true);
  const [specialCommissions, setSpecialCommission] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [exportData, setExportData] = useState([]);
  const [title, setTitle] = useState("Special Commissions");
  const [tabValue, setTabValue] = useState("doctor");

  const { type, id } = useParams();

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`special-commission/${id}`)
          .then((response) => {
            Swal.fire({
              title: "Deleted!",
              text: "Successfully deleted.",
              icon: "success",
              confirmButtonText: "OK",
            });
            setSpecialCommission((prev) =>
              prev.filter((item) => item._id !== id),
            );
          })
          .catch((error) => {
            Swal.fire({
              title: "Error",
              text: error.response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const _export = React.useRef(null);
  const excelExport = () => {
    const data = filteredData.map((item, index) => ({
      no: index + 1,
      name:
        tabValue === "doctor"
          ? item.relatedDoctor?.name || "N/A"
          : item.relatedTherapist?.name || "N/A",
      treatmentName: item.relatedTreatment?.name || "N/A",

      commission:
        item.commissionType === "Percent"
          ? `${item.commissionAmount || 0}%`
          : item.commissionAmount || 0,
    }));

    setExportData(data);

    setTimeout(() => {
      if (_export.current) {
        _export.current.save();
      }
    }, 0);
  };

  const getSpecialCommission = async (page = 1, limit = 10) => {
    try {
      const res = await api.get("special-commissions", {
        params: {
          page,
          limit,
          commissionFor: tabValue === "doctor" ? "Doctor" : "Therapist",
        },
      });

      setSpecialCommission(res.data.data);
      setTotalCount(res.data._metadata.count);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredData = specialCommissions;

  useEffect(() => {
    getSpecialCommission(page + 1, rowsPerPage);
  }, [tabValue]);

  const getRelatedSpecialCommission = async (
    id,
    type,
    page = 1,
    limit = 10,
  ) => {
    try {
      let url = `special-commissions`;

      if (type === "doctor") {
        url += `?doctorId=${id}`;
      } else if (type === "treatment") {
        url += `?treatmentId=${id}`;
      }

      const res = await api.get(url);

      setSpecialCommission(res.data.data);
      setTotalCount(res.data._metadata.count);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getSpecialCommission(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    getSpecialCommission(1, newLimit);
  };

  const handleSearch = async (keyword) => {
    setSearchTerm(keyword);

    try {
      const res = await api.get("special-commissions", {
        params: {
          search: keyword,
          commissionFor: tabValue === "doctor" ? "Doctor" : "Therapist",
        },
      });
      setSpecialCommission(res.data.data);
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  useEffect(() => {
    if (!id) {
      getSpecialCommission();
      return;
    }

    if (type === "doctor") {
      getRelatedSpecialCommission(id, "doctor");
    } else if (type === "treatment") {
      getRelatedSpecialCommission(id, "treatment");
    }
  }, [id, type]);

  useEffect(() => {
    if (!id) {
      setTitle("Special Commissions");
      return;
    }

    const firstItem = specialCommissions[0];

    if (type === "doctor") {
      const name = firstItem?.relatedDoctor?.name;
      setTitle(
        name
          ? `Special Commission for ${name}`
          : "Special Commission for Doctor",
      );
    } else if (type === "treatment") {
      const name = firstItem?.relatedTreatment?.name;
      setTitle(
        name
          ? `Special Commission for ${name}`
          : "Special Commission for Treatment",
      );
    }
  }, [specialCommissions, id, type]);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <div>
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12"></div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content">
            <div className="container-fluid px-2">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                px={2}
                pb={3}
                pt={2}
              >
                <h4 className="fs-4" style={{ margin: 0 }}>
                  {title}
                </h4>

                <Stack direction="row" spacing={1} alignItems="center">
                  <TextField
                    type="search"
                    placeholder="Search..."
                    size="small"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                    sx={{
                      width: 200,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    disableRipple
                    sx={{
                      height: 40,
                      minWidth: 90,
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "success.main",
                        boxShadow: "none",
                      },
                    }}
                    onClick={excelExport}
                  >
                    Export
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disableRipple
                    sx={{
                      height: 40,
                      minWidth: 90,
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "primary.main",
                        boxShadow: "none",
                      },
                    }}
                    onClick={() => navigate("/special-commission-create")}
                  >
                    Add
                  </Button>
                </Stack>
              </Box>
              <Box px={2} pb={2}>
                <Tabs
                  value={tabValue}
                  onChange={(e, newValue) => {
                    setTabValue(newValue);
                  }}
                  textColor="primary"
                  indicatorColor="primary"
                >
                  <Tab label="Doctor" value="doctor" />
                  <Tab label="Therapist" value="therapist" />
                </Tabs>
              </Box>
              <section className="content" style={{ paddingBottom: "1.5rem" }}>
                <div className="container-fluid px-2">
                  <div class="card-body">
                    <ExcelExport data={exportData} ref={_export}>
                      <ExcelExportColumn field="no" title="No" width={50} />
                      <ExcelExportColumn
                        field="name"
                        title={
                          tabValue === "doctor"
                            ? "Doctor Name"
                            : "Therapist Name"
                        }
                        width={200}
                      />
                      <ExcelExportColumn
                        field="treatmentName"
                        title="Treatment"
                        width={200}
                      />
                      <ExcelExportColumn
                        field="commission"
                        title="Commission"
                        width={150}
                      />
                    </ExcelExport>
                    <div className="row">
                      <div class="col-md-12 card px-3 py-3">
                        <div class="table-responsive text-black" id="slimtest2">
                          <TableContainer
                            component={Paper}
                            sx={{ maxWidth: "100%", overflowX: "auto" }}
                          >
                            <Table stickyHeader>
                              <TableHead>
                                <TableRow
                                  sx={{ backgroundColor: "primary.main" }}
                                >
                                  <TableCell
                                    sx={{
                                      color: "black",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    #
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color: "black",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Name
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color: "black",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Treatment
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color: "black",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Commission
                                  </TableCell>
                                  <TableCell
                                    className="text-center"
                                    sx={{
                                      color: "black",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Action
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {filteredData.map((sc, i) => (
                                  <TableRow key={sc._id}>
                                    <TableCell>
                                      {page * rowsPerPage + i + 1}
                                    </TableCell>
                                    <TableCell>
                                      {tabValue === "doctor"
                                        ? sc.relatedDoctor?.name || "N/A"
                                        : sc.relatedTherapist?.name || "N/A"}
                                    </TableCell>
                                    <TableCell>
                                      {sc.relatedTreatment?.name || "N/A"}
                                    </TableCell>
                                    <TableCell>
                                      {sc.commissionAmount || 0}
                                      {sc.commissionType === "Percent"
                                        ? "%"
                                        : ""}
                                    </TableCell>
                                    <TableCell className="text-center">
                                      <Link
                                        to={
                                          "/special-commission-update/" + sc._id
                                        }
                                        className="btn btn-sm btn-warning text-light"
                                      >
                                        <FaRegEdit />
                                      </Link>
                                      &nbsp;
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(sc._id)}
                                      >
                                        <FaRegTrashAlt />
                                      </button>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <TablePagination
                            component="div"
                            count={totalCount}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            labelRowsPerPage="Rows per page"
                            sx={{
                              marginTop: "12px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              "& .MuiTablePagination-toolbar": {
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                              },
                              "& .MuiTablePagination-spacer": {
                                flex: "0 0 auto",
                              },
                              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                                {
                                  marginTop: 0,
                                  marginBottom: 0,
                                },
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <CommissionDialog
                open={open}
                close={() => setOpen(false)}
                expenseLists={expenseLists}
                setExpenseLists={setExpenseLists}
              /> */}
                </div>
                {/*<!-- /.container-fluid --> */}
              </section>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};
export default SpecialCommission;
